import {CommentEN} from "./comment/en";
import {EditorEN} from "./editor/en";
import {DocumentEN} from "./document/en";
import {ActionBarEN} from "./action-bar/en";

export const CommonEN = {
    "common": {
        "noExists": "No exist",
        "noData" : "No Data",
        "description": "Description",
        "goBackModal": "Do you want to keep the page after successful implementation?",
        btn: {
          delete: "Delete",
          cancel: "Cancel"
        },

        "showAgain": "Don't show again",
        "required": "is required!",

        "all": "All",

        "add": "Create",
        "update": "Update",
        "delete": "Delete",
        "create": "Create",
        "cancel": "Cancel",
        "yes": "Yes",
        "no": "No",
        "addField": "Add field",
        "addAndSend": "Create and send",
        "updateAndSend": "Update and send",
        "enable": "Enable",
        "disable": "Disable",

        "validate": {
            "required": "is required!",
        },
        "working" : "Working",
        "waiting" : "Waiting",
        "dropTemp" : "DropTemp",
        "resignation" : "Resignation",
        "pending": "Pending",
        "approved": "Approved",
        "trashed": "Trashed",
        "actived": "Actived",
        "active": "Active",
        "inactive": "Inactive",
        "inactived": "Inactived",
        "expired": "Expired",
        "denied": "Denied",
        "incomplete": "Incomplete",
        "doing": "Doing",
        "unevaluated": "Unevaluated",
        "evaluated": "Evaluated",
        "draft": "Draft",
        "storage": "Storage",
        "status": "Status",
        "changed": " Changed",
        "back": "Back",
        "backHome" : "Back Home",
        "title403" : "Sorry, you are not authorized to access this page.",
        "title404" : "Sorry, the page you visited does not exist.",
        "title500" : "Sorry, something went wrong !",

        "message": {
            "add": "Create successfully",
            "update": "update successfully",
            "delete": "Delete successfully",
            "deleteAsk": "Are you want to delete?"
        },
        "labelCurrent":{
            "null" : "Does not exist"
        }
    },

    ...CommentEN,
    ...EditorEN,
    ...DocumentEN,
    ...ActionBarEN
}
